module.exports = __webpack_public_path__ + "static/media/ukcert.8e1dcf09.png";